import { createApi } from '@reduxjs/toolkit/query/react';
import { baseUrl, fetchLandlordIds } from '../../../../../serverUrl';
import { baseQueryWithAuth } from '../../baseQueryWithAuth.ts';

const getLandlordId = async () => {
  try {
    const landlordId = await fetchLandlordIds();
    return landlordId;
  } catch (error) {
    console.error('Error fetching Landlord ID:', error);
    return null;
  }
};

export const subscriptionSlice = createApi({
  reducerPath: 'subscriptionApi',
  baseQuery: baseQueryWithAuth,
  tagTypes: ['Subscription'],
  endpoints: (builder) => ({
    getLandlordSubscriptionStatus: builder.query({
      async queryFn(_arg, _queryApi, _extraOptions, baseQuery) {
        const landlordId = await getLandlordId();
        if (!landlordId) {
          return { error: { status: 500, data: "Landlord ID not found" } };
        }

        return baseQuery(
          `landlord/landlord-subscriptions-invoice/?landlord_id=${landlordId}`
        );
      },
      providesTags: ['Subscription'],
    }),
    getSubscriptionPlan: builder.query({
      async queryFn(companyId, _queryApi, _extraOptions, baseQuery) {
        return baseQuery(
          `/landlord/subscription-amount-units/?company_id=${companyId}`
        );
      },
      providesTags: ['Subscription'],
    }),

    getCompanyWalleSubscription: builder.query({
      async queryFn(_arg, _queryApi, _extraOptions, baseQuery) {
        const landlordId = await getLandlordId();
        if (!landlordId) {
          return { error: { status: 500, data: "Landlord ID not found" } };
        }

        return baseQuery(
          `landlord/get-wallet-apartment/?landlord_id=${landlordId}`
        );
      },
      providesTags: ['Subscription'],
    }),
    postSubscriptionPlan: builder.mutation({
      query: (subscriptionData) => ({
        url: '/landlord/subscriptions/',
        method: 'POST',
        body: subscriptionData,
      }),
      invalidatesTags: ['Subscription'],
    }),
    getPropertyDeposits: builder.query({
      async queryFn(apartmentId, _queryApi, _extraOptions, baseQuery) {
        if (apartmentId === 'all') {
          const landlordId = await getLandlordId();
          if (!landlordId) {
            return { error: { status: 500, data: "Landlord ID not found" } };
          }
          return baseQuery(
            `/landlord/units-deposits/?landlord_id=${landlordId}`
          );
        }
        return baseQuery(
          `/landlord/units-deposits/?apartment=${apartmentId}`
        );
      },
      providesTags: ['Subscription'],
    }),
    getPropertyUnitsTenant: builder.query({
      async queryFn(apartmentId, _queryApi, _extraOptions, baseQuery) {
        if (apartmentId === 'all') {
          const landlordId = await getLandlordId();
          if (!landlordId) {
            return { error: { status: 500, data: "Landlord ID not found" } };
          }
          return baseQuery(
            `/landlord/unit-tenant-apartment/?landlord_id=${landlordId}`
          );
        }
        return baseQuery(
          `/landlord/unit-tenant-apartment/?apartment_id=${apartmentId}`
        );
      },
      providesTags: ['Subscription'],
    }),
    postPropertyDeposits: builder.mutation({
      query: (unitDepoitData) => ({
        url: '/landlord/units-deposits/',
        method: 'POST',
        body: unitDepoitData,
      }),
      invalidatesTags: ['Subscription'],
    }),
    updatePropertyDeposits: builder.mutation({
      query: ({ unitDepositData, depositId }) => ({
        url: `/landlord/units-deposits/${depositId}/`,
        method: 'PATCH',
        body: unitDepositData,
      }),
      invalidatesTags: ['Subscription'],
    }),

  }),
});

export const { useGetLandlordSubscriptionStatusQuery, useGetSubscriptionPlanQuery, useGetCompanyWalleSubscriptionQuery, usePostSubscriptionPlanMutation, useGetPropertyDepositsQuery, useGetPropertyUnitsTenantQuery, usePostPropertyDepositsMutation, useUpdatePropertyDepositsMutation } = subscriptionSlice;
